<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Alerts" pageTitle="Alerts" />
            <AlertsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AlertsContent from '../Alerts/AlertsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AlertsPage',
    components: {
        MainHeader,
        PageTitle,
        AlertsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>